import { TabPanel as MuiTabPanel, TabPanelProps as MuiTabPanelProps } from "@mui/lab";
import { styled } from "@mui/material";

const StyledTabPanel = styled(MuiTabPanel)(() => ({
  // ... existing styles
}));

interface TabPanelProps extends MuiTabPanelProps {}

export const TabPanel: React.FC<TabPanelProps> = ({ children, ...props }) => {
  return <StyledTabPanel {...props}>{children}</StyledTabPanel>;
};

export default TabPanel;
